<template>

  <div>
    <v-data-table :headers="headers"
                  :items="items"
                  :pagination.sync="pagination_"
                  :total-items="totalItems"
                  :rows-per-page-items="paginationOptions"
                  :loading="loading"
                  :no-data-text="'-'">
      <v-progress-linear slot="progress"
                         color="primary"
                         indeterminate="indeterminate"></v-progress-linear>
      <template slot="items" slot-scope="props" v-show="!loading">

        <!-- ID -->
        <td :class="$vuetify.breakpoint.name">
          <ExternalId :id="props.item.id" :path="'/video/' + props.item.id" />
        </td>

        <!-- SPORT -->
        <td :class="$vuetify.breakpoint.name">{{ getSportName(props.item.sportID) }}</td>

        <!-- DATE -->
        <td :class="$vuetify.breakpoint.name">{{ formatDate(props.item.date) }}</td>

        <!-- AUTHOR -->
        <td :class="$vuetify.breakpoint.name"><b>{{ props.item.authorPreferredUsername }}</b></td>

        <!-- TYPE -->
        <td :class="$vuetify.breakpoint.name"><b>{{ props.item.type === 'summary' ? props.item.type.toUpperCase() : props.item.type }}</b></td>

        <!-- CLUB 1 -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.club1Alias }}</td>

        <!-- CLUB 2 -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.club2Alias }}</td>

        <!-- VIEWS -->
        <td :class="$vuetify.breakpoint.name" class="text-center">{{ props.item.hitCounter }}</td>

        <!-- MATCH -->
        <td :class="$vuetify.breakpoint.name">{{ props.item.matchID }}</td>

        <!-- BUTTONS -->
        <TableButtons :item="props.item"
                      :index="props.index"
                      @edit="edit"
                      @del="del"
                      @suspend="suspend"
                      @unsuspend="unsuspend"/>

      </template>
    </v-data-table>
  </div>

</template>

<script>

import { getSportInfos } from '../../helpers/get-sport-infos'
import ExternalId from '../tables/ExternalId.vue'

import TableButtons from './TableButtons'

export default {
  name: 'Table',
  components: {
    TableButtons,
    ExternalId
  },
  props: [
    'headers',
    'items',
    'pagination',
    'paginationOptions',
    'totalItems',
    'loading'
  ],
  methods: {
    getSportName (sportid) {
      return getSportInfos({id: sportid}).names['default']
    },
    formatDate (date) {
      return new Date(date).toLocaleString(`${this.$localeRegion}-${this.$country}`)
    },

    edit (index) {
      this.$emit('edit', index)
    },
    del (item) {
      this.$emit('del', item)
    },
    suspend (item) {
      this.$emit('suspend', item)
    },
    unsuspend (item) {
      this.$emit('unsuspend', item)
    }
  },
  computed: {
    pagination_: {
      get () {
        return this.pagination
      },
      set (v) {
        window.scrollTo(0, 0)
        this.$emit('paginationUpdate', v)
      }
    }
  }
}

</script>

<style lang="scss" scoped>

  td {
    &.xs {
      font-size: 11px !important;
      padding: 0 6px !important;
    }
  }

  .text-center {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/videos/Table.vue